import Button from "components/buttons/Button"
import useTranslations from "hooks/useTranslations"
import cc from "classcat"

type ScrollButtonProps = {
  bgStyle?:
    | "primary"
    | "light"
    | "dark"
    | "blue"
    | "yellow"
    | "cadetblue"
    | "black"
    | "green"
  left?: boolean
  scrollToId: string
  labelKey?: string
}

const ScrollButton = ({
  bgStyle = "primary",
  left,
  scrollToId,
  labelKey = "schoolWebinarRequestLinkText",
}: ScrollButtonProps) => {
  const translations = useTranslations()
  const label =
    translations[labelKey] || translations.schoolWebinarRequestLinkText

  return (
    <div className={cc(["max-w-xs", left ? "" : "mx-auto"])}>
      <Button bgStyle={bgStyle} label={label} link={`#${scrollToId}`} />
    </div>
  )
}

export default ScrollButton
